import {sort} from "../properties/sort";
import {filter} from "./properties/filter";
import {pagination} from "../properties/pagination";
import {model} from "./properties/model";
import { i18n } from '@/utils/i18n';

export const mutations = {
    SET_LIST: (state, hospitalPatients) => {
        state.list = hospitalPatients
    },
    SET_FILTER: (state,filter) => (state.filter = filter),
    SET_LAST_ID: (state, lastId) => (state.lastId = lastId),
    INCREMENT_LAST_ID: (state) => (++state.lastId),
    SET_INVENTORY: (state,list) => state.inventory = list,
    SET_PAGINATION: (state,pagination) => (state.pagination = pagination),
    SET_SORT: (state,sort) => (state.sort = sort),
    SET_MODEL: (state, model) => {
        state.model = model;
        state.patientName = model.surname + ' ' + model.first_name;
    },
    UPDATE_COLUMN: (state, obj) => {
        state.columns[obj.key].show = obj.value
    },
    UPDATE_SORT: (state, sort) => {
        state.sort[sort.column] = sort.order
    },
    UPDATE_PAGINATION: (state, pagination) => {
        state.pagination[pagination.key] = pagination.value
    },
    EMPTY_MODEL: (state) => {
        state.model = JSON.parse( JSON.stringify( model ));
    },
    
    REFRESH: (state) => {
        state.filter = JSON.parse( JSON.stringify( filter ));
        state.sort = JSON.parse( JSON.stringify( sort ));
        state.pagination = JSON.parse( JSON.stringify( pagination ));
    },
    SET_CODE: (state,val) => {
        state.activeCode = val;
    },
    UPDATE_LANG_COLUMN: (state) => {
            state.columns.id.title = "№";
            state.columns.dob.title = i18n.t('message.dob');
            state.columns.city.title = i18n.t('message.city');
            state.columns.code.title = i18n.t('message.code_id');
            state.columns.gender.title = i18n.t('message.gender');
            state.columns.state.title = i18n.t('message.country');
            state.columns.region.title = i18n.t('message.region');
            state.columns.button.title =  i18n.t('message.view_0');
            state.columns.created_at.title = i18n.t('message.date');
            state.columns.surname.title = i18n.t('message.surname');
            state.columns.settings.title = i18n.t('message.settings');
            state.columns.patronymic.title = i18n.t('message.patronymic');
            state.columns.updated_at.title = i18n.t('message.update_date');
            state.columns.hospitalPatient.title = i18n.t('message.first_name');
            state.columns.passport_number.title = i18n.t('message.passport_number');
            
    }
};
